import React from 'react';
import { createContact, sendOtp, validateOtp , getContactByPhone } from '../../utils/ApiService';
import { Cropped, Overlay } from '../../pages/Layouts';

const sendOtpTo = async (email, phone, otpto) => {
  const optpTo = otpto.toLocaleLowerCase();
  let queryParams;
  switch (optpTo) {
    case 'email':
      queryParams = `email=${email}`;
      break;

      queryParams = null;
      break;
  }
  if (queryParams) {
    return sendOtp(queryParams).then((res) => {
      return res;
    });
  } else return null;
};

const isOtpValid = async (email, phone, otpto, otp) => {
  const optpTo = otpto.toLocaleLowerCase();
  let queryParams;
  switch (optpTo) {
    case 'both':
      queryParams = `email=${email}&mobileno=${phone}&otp=${otp}`;
      break;
    case 'sms':
      queryParams = `mobileno=${phone}&otp=${otp}`;
      break;
    case 'email':
      queryParams = `email=${email}&otp=${otp}`;
      break;

    default:
      queryParams = null;
      break;
  }

  if (queryParams) {
    return validateOtp(queryParams).then((res) => {
      return res;
    });
  } else return null;
};

const isUserAlreadyRegistered = async (phone) => {
  try {
    const resp = await getContactByPhone(phone);
    if (
      resp &&
      resp.Message !== 'No contact matched'
    ) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const getContactId = async (phone) => {
  try {
    const resp = await createContact({ Phone: phone });
    return resp.ContactId;
  } catch {
    return 'null';
  }
};

const storeInfo = (info, phone) => {
  localStorage.setItem('contactID', info.Id);
  localStorage.setItem('userPhone', phone);
};

const getLayout = (layout) => {
  switch (layout?.toLocaleLowerCase()) {
    case 'cropped':
      return <Cropped></Cropped>;
    case 'overlay':
      return <Overlay></Overlay>;
  }
};

export {
  sendOtpTo,
  isOtpValid,
  isUserAlreadyRegistered,
  getContactId,
  storeInfo,
  getLayout,
};
